import { useTranslation } from "react-i18next";

import Button from "./common/Button";
import setOpeningDateString from "../utilities/setOpeningDateString";


import { useTabStore } from "../store/tab-store";
import Contact from "./Contact";

function Intro(props) {
  const { t, i18n } = useTranslation();
  
  const langFull = {de: "german", en: "english", fr: "french", it: 'italian'};
  const showOpeningDate = (props.data.status.openingDate) ? setOpeningDateString(props.data.status.openingDate, t("intro.open_intro")): false;
  const showOpening = (props.data.status.isPresale) ? t("intro.coming_soon"): false;
  const memberLink = props.data.links.custom_link?.[props.lang.lang] ? props.data.links.custom_link[props.lang.lang] : props.data.links.exerp+'/join/plan?center='+ props.shopId + '&lang='+langFull[props.lang.lang];
  
  const openingElement =  showOpeningDate ? t("intro.presale_intro", {date: showOpeningDate}) : showOpening;
  
  const [setTab] = useTabStore((state) => [state.setTab]);
  const lgf = props.lgf === 'true' || props.lgf === "1";
  if(lgf) props.data.lgf = true; 
  return (
    <>
      <div className="tw-h-pg-full tw-min-h-[540px] md:tw-h-auto md:tw-min-h-min tw-relative tw-z-30 tw-bg-teal-light tw-text-white tw-pb-12">
        <div className="tw-h-full tw-flex tw-flex-col md:tw-flex-row tw-m-auto tw-max-w-screen-lg tw-pb-8">
          <div className="tw-flex-1 tw-pb-0 xs:tw-pb-5  tw-p-5 lg:tw-pl-0">
          {openingElement && (<p className="tw-rounded-2xl tw-text-teal-light tw-bg-yellow tw-inline-block tw-px-4 tw-py-1 tw-font-condensed tw-text-lg tw-leading-6 tw-uppercase">
            {
              /*t("intro.presale_intro", {
                date: showOpening,
                })*/ openingElement
            }
          </p>)}
            <h1 className="tw-font-condensed tw-font-black tw-text-4xl xs:tw-text-4xl tw-uppercase tw-italic">
              Puregym&nbsp;
              <br className="tw-hidden md:tw-block" />
              <span className="tw-whitespace-nowrap tw-block">{props.data.name}</span>
            </h1>
            {lgf && (
              <p className="tw-text-yellow tw-font-condensed tw-text-lg tw-leading-6 tw-uppercase">
                {t("intro.lgf_available")}
              </p>
            )}
            <Contact data={props.data} addressOnly={true}/>
            
          </div>
          <div className="tw-flex-initial xs:tw-pt-4 tw-pt-2 tw-p-4 lg:tw-pr-0">
            <div className="tw-bg-white tw-text-black tw-rounded-lg md:tw-rounded-xl tw-p-5 tw-pt-3 tw-flex tw-flex-col tw-text-center md:tw-max-w-md md:tw-ml-auto">
              <span className="tw-font-condensed tw-font-black tw-text-2xl md:tw-text-3xl tw-uppercase tw-italic">
                {(props.data.bestOffer.core12 && t("intro.available_from", {
                  price: props.data.bestOffer.core12/12,
                }))}
              </span>
              <span className="tw-uppercase">{t("intro.cancel_anytime")}</span>
              {!props.data.status.isComingSoon && (
                <Button
                  href={memberLink}
                  title={props.data.status.isPresale && !showOpeningDate? t("buttons.interest"): t("buttons.register")}
                  color="orange"
                  type="fill"
                  size="large"
                  className="tw-mt-3 md:tw-mt-5"
                />
              )}
              <Button
                title={t("buttons.register_options")}
                color="black"
                type="outline"
                size="medium"
                className="tw-mt-2"
                onClick={() => {
                  setTab("overview");

                  setTimeout(() => {
                    const target = document.getElementById("options");
                    target?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
              />
              {props.data.status.isComingSoon || openingElement && (
                <span className="tw-pt-4 tw-pb-1 tw-font-condensed tw-font-black tw-text-2xl tw-leading-5 tw-uppercase tw-text-orange">
                  {openingElement}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Intro;
